import { reducer as failedDelivery } from "./failed-delivery/slice";

export const reducer = {
  failedDelivery,
};
